import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { theme } from '@revenuemarket/design';

import { SpinnerProps } from './Spinner';

const animCircle = keyframes`
  0%,100% {
    opacity: 1;
  }

  50% {
    opacity: 0.3;
  }
`;

export const Wrapper = styled.div<SpinnerProps>`
  display: flex;
  justify-content: center;
`;

export const LoadingWrapper = styled.div`
  display: inline-block;
  position: relative;
  width: 42px;
  height: 42px;
`;

export const Circle = styled.div`
  position: absolute;
  width: 9px;
  height: 9px;
  background-color: ${theme.colors.teal1000};
  border-radius: 50%;
  animation: ${animCircle} 1s infinite linear;

  &:nth-of-type(1) {
    top: 0;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    animation-delay: 0.1s;
  }

  &:nth-of-type(2) {
    top: 5px;
    right: 5px;
    animation-delay: 0.2s;
  }

  &:nth-of-type(3) {
    top: 50%;
    right: 0;
    transform: translate3d(0, -50%, 0);
    animation-delay: 0.3s;
  }

  &:nth-of-type(4) {
    bottom: 5px;
    right: 5px;
    animation-delay: 0.4s;
  }

  &:nth-of-type(5) {
    bottom: 0;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    animation-delay: 0.5s;
  }

  &:nth-of-type(6) {
    bottom: 5px;
    left: 5px;
    animation-delay: 0.6s;
  }

  &:nth-of-type(7) {
    top: 50%;
    left: 0;
    transform: translate3d(0, -50%, 0);
    animation-delay: 0.7s;
  }

  &:nth-of-type(8) {
    top: 5px;
    left: 5px;
    animation-delay: 0.8s;
  }
`;
